export default "__VITE_ASSET__CpmXXYiU__"